// extracted by mini-css-extract-plugin
export default {"zoomModal":"S1-z"};